document.addEventListener('DOMContentLoaded', function () {

  /* ---- scroll reveal ---- */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }
  var hero = document.querySelector('.hero');
  if (hero) requestAnimationFrame(function () { hero.classList.add('in'); });

  /* ---- mobile nav ---- */
  var menuBtn = document.querySelector('.menu-btn');
  var mobileNav = document.querySelector('.mobile-nav');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
    });
  }

  /* ---- accordions (product page) ---- */
  document.querySelectorAll('.acc-head').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.parentElement;
      var body = item.querySelector('.acc-body');
      var isOpen = item.classList.contains('open');
      item.parentElement.querySelectorAll('.acc-item').forEach(function (i) {
        i.classList.remove('open');
        i.querySelector('.acc-body').style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add('open');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  });
  document.querySelectorAll('.acc-item.open .acc-body').forEach(function (b) {
    b.style.maxHeight = b.scrollHeight + 'px';
  });

  /* ---- gallery thumbnails ---- */
  document.querySelectorAll('.thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      var img = t.getAttribute('data-full');
      var mainImg = document.querySelector('.main-image img');
      if (img && mainImg) mainImg.src = img;
      document.querySelectorAll('.thumb').forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
    });
  });

  /* ---- quantity steppers ---- */
  document.querySelectorAll('.qty').forEach(function (qtyEl) {
    var input = qtyEl.querySelector('input');
    var minus = qtyEl.querySelector('[data-qty-minus]');
    var plus = qtyEl.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      var v = parseInt(input.value || '1', 10);
      if (v > 1) input.value = v - 1;
      input.dispatchEvent(new Event('change'));
    });
    if (plus) plus.addEventListener('click', function () {
      var v = parseInt(input.value || '1', 10);
      input.value = v + 1;
      input.dispatchEvent(new Event('change'));
    });
  });

  /* ---- variant swatches ---- */
  document.querySelectorAll('.swatches').forEach(function (group) {
    group.querySelectorAll('.swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        if (sw.classList.contains('sold-out')) return;
        group.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('selected'); });
        sw.classList.add('selected');
        var hiddenInput = group.closest('form').querySelector('[data-variant-id]');
        if (hiddenInput && sw.dataset.variantId) hiddenInput.value = sw.dataset.variantId;
      });
    });
  });

  /* ---- AJAX add to cart ---- */
  document.querySelectorAll('[data-add-to-cart-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-add-to-cart-btn]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('[name="id"]').value,
          quantity: parseInt(form.querySelector('[name="quantity"]').value || '1', 10)
        })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          if (btn) { btn.textContent = 'Added ✓'; }
          updateCartCount();
          setTimeout(function () { if (btn) { btn.textContent = original; btn.disabled = false; } }, 1600);
        })
        .catch(function () {
          if (btn) { btn.textContent = original; btn.disabled = false; }
        });
    });
  });

  function updateCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = cart.item_count; });
    });
  }

  /* ---- cart page: change quantity / remove ---- */
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: input.dataset.line, quantity: input.value })
      }).then(function () { window.location.reload(); });
    });
  });
  document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: btn.dataset.line, quantity: 0 })
      }).then(function () { window.location.reload(); });
    });
  });

});
